import { isDuplicateConversionEvent } from '@rehub/tracking';
import { supabase, isConfigured } from '../services/supabase';

const PURCHASE_OR_SIGNUP = new Set([
  'sketchplan_guest_payment_completed',
  'sketchplan_post_purchase_signup_started',
]);

export type SketchplanAnalyticsEvent =
  | 'sketchplan_guest_order_started'
  | 'sketchplan_guest_service_selected'
  | 'sketchplan_guest_upload_completed'
  | 'sketchplan_guest_checkout_started'
  | 'sketchplan_guest_payment_completed'
  | 'sketchplan_post_purchase_signup_started'
  | 'sketchplan_guest_order_claimed'
  | 'sketchplan_client_login_clicked';

/** Fire-and-forget analytics. Never send names, emails, addresses or filenames. */
export function trackSketchplan(event: SketchplanAnalyticsEvent, metadata: Record<string, string | number | boolean | null> = {}) {
  try {
    const safe: Record<string, string | number | boolean | null> = {};
    for (const [key, value] of Object.entries(metadata)) {
      if (/email|name|address|filename|file|phone/i.test(key)) continue;
      safe[key] = value;
    }
    const skipPlatform = PURCHASE_OR_SIGNUP.has(event) || isDuplicateConversionEvent(event);
    if (!skipPlatform && typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', event, safe);
    }
    if (isConfigured) {
      void supabase.rpc('log_event', {
        p_event_type: event,
        p_user_id: null,
        p_user_email: null,
        p_ip_address: null,
        p_user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
        p_metadata: safe,
      });
    }
  } catch {
    /* ignore analytics failures */
  }
}
